module.exports = __webpack_public_path__ + "img/blito.099384d3.svg";